import http from "@/http/aisea/axios";
const resource = "/enterprises/owners";

export default {
  fetchOwners(params) {
    return http.get(`${resource}`, {
      params: params,
    });
  },
  fetchManningVessels(params) {
    return http.get(`${resource}/manning_vessels`, {
      params: params,
    });
  },
};
